<div class="wrapper">
    <div class="row table-toolbar">
        <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div class="advancedSearch">
                <button type="button" mat-raised-button>
                    <span><mat-icon svgIcon="filter"></mat-icon></span>
                    <span>Advanced Search</span> 
                </button>
            </div>

        </div>
        <div class="cal-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-paginator #paginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
        </div>
        <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
            <div class="button-group">
                <button type="button" class="btn-int-blue" (click)="createHoliday()" mat-raised-button>Create Holiday</button>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="mat-table-responsive">
                <table mat-table [dataSource]="holidaysDataSource">

                    <ng-container matColumnDef="org_name">
                        <th mat-header-cell *matHeaderCellDef> Organization </th>
                        <td mat-cell *matCellDef="let element"> {{element?.org_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="holiday_on">
                        <th mat-header-cell *matHeaderCellDef> Date </th>
                        <td mat-cell *matCellDef="let element"> {{element?.holiday_on}} </td>
                    </ng-container>

                    <ng-container matColumnDef="holiday_for">
                        <th mat-header-cell *matHeaderCellDef> Holiday </th>
                        <td mat-cell *matCellDef="let element"> {{element?.holiday_for}} </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="holidaysDisplayedColumns | tableShowColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: holidaysDisplayedColumns | tableShowColumns;"></tr>
                </table>
                <ng-container *ngIf="holidaysDataSource?.filteredData?.length == 0">
                    <div class="row forNoRecords">
                        <h3 class="table-no-date"> No Record found</h3>
                    </div>
                </ng-container>
                <app-table-loader></app-table-loader>

            </div>
        </div>
    </div>
</div>